import api from "!../../../../../../tmp/drone/cache/d3435c3c293f26acee18f9dc6f4f34fd502b0302d69785ad50a44034269e34e0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../tmp/drone/cache/d3435c3c293f26acee18f9dc6f4f34fd502b0302d69785ad50a44034269e34e0/node_modules/css-loader/index.js??ruleSet[1].rules[1].use[1]!./yellowHiveCss.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};